let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cKVf8")).then(() => parcelRequire('38BJH'));